<template>
  <div>
    <el-card shadow="never" class="mb-2">
      <InspectionDescriptions :info="info" />

      <div class="inspection-buttons">
        <el-button
          v-if="
            allow('M') &&
              pendingGoodsInspectionCode &&
              !edit &&
              ['N'].includes(status)
          "
          type="info"
          size="small"
          @click="startEdit()"
        >
          {{ $l('btn_edit_inspection_record') || '编辑巡检记录' }}
        </el-button>
        <el-button
          v-if="
            allow('D') && pendingGoodsInspectionCode && ['N'].includes(status)
          "
          type="danger"
          size="small"
          @click="del()"
        >
          {{ $l('btn_del_inspection_record') || '删除巡检记录' }}
        </el-button>
        <el-button
          v-if="
            allow('R') &&
              pendingGoodsInspectionCode &&
              ['N'].includes(status) &&
              ['P'].includes(checkStatus)
          "
          type="warning"
          size="small"
          @click="recheck()"
        >
          {{ $l('btn_recheck_inspection_record') || '复检完成' }}
        </el-button>
        <el-button
          v-if="
            allow('S') && pendingGoodsInspectionCode && ['N'].includes(status)
          "
          type="success"
          size="small"
          @click="submit()"
        >
          {{ $l('btn_submit_inspection_record') || '正式提交巡检记录' }}
        </el-button>
        <el-button
          v-if="edit"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
        >
          {{ $l('btn_save_inspection_record') || '仅保存记录' }}
        </el-button>
      </div>
    </el-card>

    <el-card shadow="never">
      <EditForm
        ref="editForm"
        :disabled="!edit"
        :pendingGoodsInspectionCode="pendingGoodsInspectionCode"
        :pendingGoodsCode="pendingGoodsCode"
        @loaded="(data) => (info = data)"
        @add-success="(data) => $emit('add-success', data)"
      />
    </el-card>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import InspectionDescriptions from '../components/inspection-descriptions'
import EditForm from '../components/edit-form'
export default {
  mixins: [EditLoading],
  components: { InspectionDescriptions, EditForm },
  props: {
    autoedit: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pendingGoodsInspectionCode: { type: String, default: '' },
    pendingGoodsCode: { type: String, default: '' },
  },
  data() {
    return { info: {}, edit: false, manualedit: false }
  },
  computed: {
    status() {
      return this.info?.status || ''
    },
    checkStatus() {
      return this.info?.checkStatus || ''
    },
    editConditions() {
      return {
        pendingGoodsInspectionCode: this.pendingGoodsInspectionCode,
        status: this.status,
        checkStatus: this.checkStatus,
        autoedit: this.autoedit,
        modifyAllow: this.allow('M'),
      }
    },
  },
  watch: {
    editConditions: {
      handler() {
        this.edit = false

        if (this.manualedit) {
          return (this.edit = true)
        }
        if (!this.pendingGoodsInspectionCode) {
          return (this.edit = true)
        }
        if (this.autoedit && this.allow('M') && ['N'].includes(this.status)) {
          return (this.edit = true)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.pendingGoodsInspectionCode) return
      if (!this.pendingGoodsCode) return

      this.loadGoods()
    },
    async loadGoods() {
      const res = await this.$api
        .pendingGoodsDetailApi(this.pendingGoodsCode)
        .catch(() => null)

      if (!res) return

      const data = res.body || {}
      this.info = {
        ...data,
        status: '',
        checkStatus: '',
        createBy: '',
        createByName: '',
        createTime: '',
        modifyBy: '',
        modifyByName: '',
        modifyTime: '',
      }
    },
    startEdit() {
      this.edit = true
      this.manualedit = true
    },
    reload() {
      this.$refs.editForm.init()
    },
    async del() {
      const confirm = await this.$confirm(
        this.$l('tips_question_del') || '请确认是否要删除巡检记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .mrpPendingGoodsInspectionDelApi({
          pendingGoodsInspectionCode: this.pendingGoodsInspectionCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        message: this.$l('tips_delete_success') || '删除成功',
        type: 'success',
      })

      this.edit = false
      this.manualedit = false
      this.reload()
    },
    async recheck() {
      const confirm = await this.$confirm(
        this.$l('tips_question_recheck') || '请确认是否要复检完成？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const result = await this.$refs.editForm
        .preSave()
        .then((res) => {
          const { status, msg } = res
          if (200 !== status) {
            this.loadingClose()

            this.$confirm(
              msg || this.$l('tips_save_no') || '保存失败',
              this.$l('tips_title_recheck') || '复检完成',
              {
                type: 'warning',
                confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
                showCancelButton: false,
              },
            )

            return false
          }

          return true
        })
        .catch(() => {
          this.loadingClose()
          return false
        })
      if (!result) return

      const res = await this.$api
        .mrpPendingGoodsInspectionRecheckApi({
          pendingGoodsInspectionCode: this.pendingGoodsInspectionCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        message: this.$l('tips_recheck_success') || '复检成功',
        type: 'success',
      })

      this.reload()
    },
    async submit() {
      const confirm = await this.$confirm(
        this.$l('tips_question_submit') || '请确认是否要正式提交巡检记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const result = await this.$refs.editForm
        .preSave()
        .then((res) => {
          const { status, msg } = res
          if (200 !== status) {
            this.loadingClose()

            this.$confirm(
              msg || this.$l('tips_save_no') || '保存失败',
              this.$l('tips_title_submit') || '正式提交巡检记录',
              {
                type: 'warning',
                confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
                showCancelButton: false,
              },
            )

            return false
          }

          return true
        })
        .catch(() => {
          this.loadingClose()
          return false
        })

      if (!result) return

      const res = await this.$api
        .mrpPendingGoodsInspectionSubmitApi({
          pendingGoodsInspectionCode: this.pendingGoodsInspectionCode,
        })
        .catch(() => null)
      this.loadingClose()

      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        message: this.$l('tips_submit_success') || '提交成功',
        type: 'success',
      })

      this.edit = false
      this.manualedit = false
      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__body {
    padding: 18px;
  }
}

.inspection-buttons {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: end;

  &:empty {
    display: none;
  }
}
</style>
